export function generateId() {
  const secondPart = (Math.random() * 46656) | 0
  const firstPartFinal = Math.floor(Math.random() * (999 - 100 + 1) + 100)
  const secondPartFinal = ('000' + secondPart.toString(36)).slice(-2)
  return firstPartFinal + secondPartFinal
}
